import ar_white from "../../../assets/images/ar_white.svg";
import home_white from "../../../assets/images/home_white.svg";

import image_mom from "../../../assets/images/image_mom.webp";
import image_ppc from "../../../assets/images/image_ppc.webp";

export default function LibraryBanner() {
  return (
    <div className="w-full ">
      <div className="block md:hidden lg:hidden w-full relative  h-[12rem]">
        <img src={image_mom} alt="mobi" className="w-full h-[12rem]" />
        <div className="w-full absolute top-0  h-[12rem] bg-blue-sky-gradient6  ">
          <div className="absolute bottom-[20%] right-[15%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-around">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Thư viện ảnh
                </p>
              </div>
            </div>
            <p className="text-[1.5rem] font-semibold text-white whitespace-nowrap">
              Thư viện ảnh
            </p>
          </div>
        </div>
      </div>
      <div className="hidden md:block lg:block w-full relative h-[20rem]">
        <img src={image_ppc} alt="pc" className="w-full h-[20rem]" />
        <div className="w-full absolute top-0  h-[20rem] bg-blue-sky-gradient6 ">
          <div className="absolute bottom-[35%] right-[40%] md:right-[35%] lg:right-[45%] lg:bottom-[25%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-around">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Thư viện ảnh
                </p>
              </div>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Thư viện ảnh
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
